/**
 * Stubbed analytics helper — maintains the same interface as the original
 * for future extraction to a shared package.
 *
 * TODO: Connect to real analytics when ready
 */

export interface SiteSearchMetricData extends Record<string, unknown> {
  terms: string[];
  totalResults: number;
}

export const SITE_SEARCH_SCHEMA = "iglu:com.snowplowanalytics.snowplow/site_search/jsonschema/1-0-0";

/**
 * Stubbed — init analytics tracker
 */
export const initAnalytics = () => {
  // Stubbed: No-op for now
  console.debug("[analytics] initAnalytics: stubbed");
};

/**
 * Stubbed — send site search metric
 */
export const sendSiteSearchMetric = (_data: SiteSearchMetricData) => {
  // Stubbed: No-op for now
};

/**
 * Stubbed — tracks a custom UXM event
 * @param touchpoint - The touchpoint identifier for the event
 * @param payload - The event payload data to be tracked
 */
export const trackUxmCustomEvent = (touchpoint: string, payload: Record<string, any>) => {
  console.debug("[analytics] trackUxmCustomEvent:", touchpoint, payload);
};
